





































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { ISigningStep } from '@signing-page/signing/types/signing-step';
import Input from '@/components/Input.vue';
import { EButtonType } from '@lib-ui/components/base-button/types/enums/button-type';

@Component({
  components: {
    Input,
  },
  data: () => ({
    EButtonType,
  }),
})
export default class VerifyQna extends Vue {
  @Prop() error: boolean;
  @Prop() step: ISigningStep;
  @Prop() loading: boolean;
  value = '';
  showError = false;

  @Watch('error')
  setError() {
    this.showError = this.error;
  }

  get label(): string {
    return this.step && this.step.data.question
      ? this.step.data.question
      : this.$t('password').toString();
  }

  handleChange() {
    this.showError = false;
  }

  close() {
    this.$emit('close');
  }

  verify() {
    this.$emit('verify', this.value);
  }
}
